import { render } from "./CompactProfileCard.vue?vue&type=template&id=660844f6"
import script from "./CompactProfileCard.vue?vue&type=script&lang=js"
export * from "./CompactProfileCard.vue?vue&type=script&lang=js"

import "./CompactProfileCard.vue?vue&type=style&index=0&id=660844f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__